var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"primary--text",attrs:{"color":"secondary","rules":[_vm.obligatoria],"label":_vm.$t('acepto_politica'),"hint":_vm.$t(_vm.esMovil ? 'hint_movil' : 'hint_web'),"persistent-hint":""},model:{value:(_vm.aceptadaLocal),callback:function ($$v) {_vm.aceptadaLocal=$$v},expression:"aceptadaLocal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }